import { EventLogger } from '@utils/event-metrics';

const loggerMiddleware = async (to, _from, _failure, next) => {
  EventLogger.init(to);

  next();
};

export { loggerMiddleware };
